import React, { useCallback, useContext } from 'react';
import { TextField, Box } from '@mui/material';
import SelectOrgChartHr from 'routes/HumanResourcesModule/PayState/PayStateHome/components/PayStateModal/SelectOrgChartHr';
import { useTranslation } from 'react-i18next';
import ModalHeader from 'ui/Modals/ModalHeader';
import OptionalFilterSelector from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationModal/components/OptionalFilterSelector/OptionalFilterSelector';
import { EtablissementAndPayBudgetContext } from 'routes/HumanResourcesModule/components/contexts/HumanResourcesContext';
import Flex from 'ui/Flex/Flex';

export type PayStateFormState = {
    title: string;
    isFormValid: boolean;
    selectedOrgChartHrsSoftwareIds: string[];
    isPayBudgetFilterActive: boolean;
    selectedPayBudgetSoftwareIds: string[];
    isEtablissementsFilterActive: boolean;
    selectedEtablissementSoftwareIds: string[];
};

type Props = {
    formState: PayStateFormState;
    setFormState: React.Dispatch<React.SetStateAction<PayStateFormState>>;
    headerTitle: string;
    exercice: number;
    editMode: boolean;
};

const PayStateForm = ({
    formState,
    editMode,
    setFormState,
    headerTitle,
    exercice,
}: Props) => {
    const { t } = useTranslation();
    const { payBudget, etablissement } = useContext(
        EtablissementAndPayBudgetContext,
    );
    const onInputChange = useCallback(
        (name: keyof PayStateFormState, value: unknown) => {
            setFormState({ ...formState, [name]: value });
        },
        [JSON.stringify(formState), setFormState],
    );

    return (
        <>
            <ModalHeader title={headerTitle} />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2em',
                }}
            >
                <TextField
                    sx={{ marginTop: '1em' }}
                    label={t('humanResources.payState.payStateTitle')}
                    required
                    value={formState.title}
                    onChange={(e) => onInputChange('title', e.target.value)}
                />
                <TextField
                    fullWidth
                    disabled
                    label={t('humanResources.exerciceTitle')}
                    defaultValue={exercice}
                />
                {!editMode && (
                    <>
                        <SelectOrgChartHr
                            selectedOrgChartHrsSoftwareIds={
                                formState.selectedOrgChartHrsSoftwareIds
                            }
                            setSelectedOrgChartHrsSoftwareIds={(value) => {
                                onInputChange(
                                    'selectedOrgChartHrsSoftwareIds',
                                    value,
                                );
                            }}
                        />
                        <Flex direction="column" gap="1em">
                            <OptionalFilterSelector
                                field="etablissement"
                                data={etablissement}
                                isFilterActive={
                                    formState.isEtablissementsFilterActive
                                }
                                setIsFilterActive={(value: boolean) => {
                                    onInputChange(
                                        'isEtablissementsFilterActive',
                                        value,
                                    );
                                }}
                                selectedItemIds={
                                    formState.selectedEtablissementSoftwareIds
                                }
                                setSelectedItemIds={(value: string[]) => {
                                    onInputChange(
                                        'selectedEtablissementSoftwareIds',
                                        value,
                                    );
                                }}
                            />
                            <OptionalFilterSelector
                                field="pay_budget"
                                data={payBudget}
                                isFilterActive={
                                    formState.isPayBudgetFilterActive
                                }
                                setIsFilterActive={(value: boolean) => {
                                    onInputChange(
                                        'isPayBudgetFilterActive',
                                        value,
                                    );
                                }}
                                selectedItemIds={
                                    formState.selectedPayBudgetSoftwareIds
                                }
                                setSelectedItemIds={(value: string[]) => {
                                    onInputChange(
                                        'selectedPayBudgetSoftwareIds',
                                        value,
                                    );
                                }}
                            />
                        </Flex>
                    </>
                )}
            </Box>
        </>
    );
};

export default PayStateForm;
